import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import type { GalleryEvent, GalleryImage } from "@/types/gallery";

export interface EventWithImages extends GalleryEvent {
  images: GalleryImage[];
  coverImage: GalleryImage | null;
  imageCount: number | null;
}

export const useGalleryEvents = (selectedCategory: string | null) => {
  return useQuery({
    queryKey: ['gallery-events', selectedCategory],
    queryFn: async () => {
      let query = supabase
        .from('gallery_events')
        .select('*, gallery_images(*)')
        .order('event_date', { ascending: false });

      if (selectedCategory) {
        query = query.eq('category', selectedCategory);
      }

      const { data: eventsData, error: eventsError } = await query;
      if (eventsError) throw eventsError;

      const eventsWithImages = (eventsData || []).map((event) => {
        const images: GalleryImage[] = (event.gallery_images || []) as GalleryImage[];
        const sortedImages = [...images].sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0));
        const coverImage = images.find((img) => img.is_cover) ?? null;

        return {
          ...event,
          images: sortedImages,
          coverImage,
          imageCount: images.length,
        };
      });

      return eventsWithImages as EventWithImages[];
    },
  });
};